// extracted by mini-css-extract-plugin
export default {"container":"O54T1xmjeK4qmU7Wo+3xPA==","tooltipText":"mfB2xHd6pd-fb4D+qWuAjg=="};